<template lang="pug">
  author-bio-tooltip.bottom(:author='author' styleClass='author-bio-popover program-author-popover')
    .author.row
      img.author-avatar(:src='author.picture || defaultProfileImage' :alt='`${author.name} avatar`')
      span.text-big.black
        | {{ author.name }}
      span.text-normal.dark-gray
        | {{ author.bio }}
</template>

<script>
import defaultProfileImage from '@/assets/empty_profile.svg'
import AuthorBioTooltip from '@/components/AuthorBioTooltip'

export default {
  components: { AuthorBioTooltip },
  props: {
    author: { type: Object, required: true }
  },
  data() {
    return {
      defaultProfileImage
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

.author {
  display: grid;
  grid-template: 'image name' 30px
    'image description' / 60px 1fr;
  gap: 0 20px;
}

.author-avatar {
  box-sizing: border-box;
  height: 60px;
  width: 60px;
  border: 1px solid $light-gray;
  border-radius: 100%;
  grid-area: image;
}

</style>
